import { render, staticRenderFns } from "./lineup_flatDoubleTeam.vue?vue&type=template&id=57a4446f&scoped=true"
import script from "./lineup_flatDoubleTeam.vue?vue&type=script&lang=js"
export * from "./lineup_flatDoubleTeam.vue?vue&type=script&lang=js"
import style0 from "./lineup_flatDoubleTeam.vue?vue&type=style&index=0&id=57a4446f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a4446f",
  null
  
)

export default component.exports